import CheckIcon from '@mui/icons-material/Check';
import { MenuItem } from '@src/common/components/Menu';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permitId: string;
  orderId: string;
}
export const CompleteApplication = forwardRef<HTMLLIElement, Props>(
  ({ permitId, orderId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const navigateToCompletePermit = () => {
      navigate(OrdersNavigation.completePermit.url(orderId, permitId));
    };

    return (
      <MenuItem
        {...menuItemProps}
        ref={ref}
        className={menuItemStyle}
        onClick={navigateToCompletePermit}
      >
        <CheckIcon style={actionIconStyle} />
        {t('permitApplication.complete')}
      </MenuItem>
    );
  },
);
